import { render, staticRenderFns } from "./IdeaResultCard.vue?vue&type=template&id=66bfc9a7&scoped=true&"
import script from "./IdeaResultCard.vue?vue&type=script&lang=js&"
export * from "./IdeaResultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfc9a7",
  null
  
)

export default component.exports